import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.component.html',
  styleUrls: ['./refund-policy.component.scss'],
})
export class RefundPolicyComponent {
  constructor(private translate: TranslateService) {}

  get isArabic(): boolean {
    return (this.translate.currentLang || '').split('-')[0] === 'ar';
  }
}
